var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponentsPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2761 0H3.72391C1.67053 0 0 1.67053 0 3.72406V16.2761C0 18.3295 1.67053 20 3.72391 20H16.2761C18.3295 20 20 18.3295 20 16.2761V3.72406C20 1.67053 18.3295 0 16.2761 0V0ZM14.707 7.44797C14.3254 7.44797 13.9668 7.34772 13.6557 7.173L10.5859 10.2428V12.6338C11.4902 12.8897 12.155 13.7219 12.155 14.707C12.155 15.8952 11.1882 16.862 10 16.862C8.8118 16.862 7.845 15.8952 7.845 14.707C7.845 13.7219 8.50983 12.8897 9.41406 12.6338V10.2428L6.3443 7.173C6.03317 7.34787 5.67459 7.44797 5.29297 7.44797C4.10477 7.44797 3.13797 6.48117 3.13797 5.29297C3.13797 4.10477 4.10477 3.13812 5.29297 3.13812C6.48117 3.13812 7.44797 4.10477 7.44797 5.29297C7.44797 5.67459 7.34772 6.03317 7.173 6.3443L10 9.1713L12.827 6.3443C12.6521 6.03317 12.552 5.67459 12.552 5.29297C12.552 4.10477 13.5188 3.13812 14.707 3.13812C15.8952 3.13812 16.862 4.10477 16.862 5.29297C16.862 6.48117 15.8952 7.44797 14.707 7.44797V7.44797Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentsPosition);
export default __webpack_public_path__ + "static/media/components_position.f4450ef10c18fa7c147524d78e702745.svg";
export { ForwardRef as ReactComponent };